import { z } from 'zod';
/** Consulta da trilha de auditoria (LGPD): quem fez o quê, quando e sobre quem. */
export const filtroAuditoriaSchema = z.object({
    usuarioId: z.uuid().optional(),
    clienteId: z.uuid().optional(),
    acao: z.string().trim().max(60).optional(),
    alvoTipo: z.string().trim().max(60).optional(),
    de: z.iso.datetime().optional(),
    ate: z.iso.datetime().optional(),
    /** Cursor: id do último item da página anterior. */
    antesDe: z.coerce.number().int().positive().optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
});
/** Ações conhecidas, para o filtro do painel (a lista real vem do banco). */
export const ACOES_AUDITORIA = {
    'login.sucesso': 'Login realizado',
    'login.falha': 'Tentativa de login falhou',
    'login.bloqueio': 'Conta bloqueada por tentativas',
    'sessao.logout': 'Logout',
    'sessao.logout_todos': 'Saiu de todos os dispositivos',
    'sessao.reuso_detectado': 'Reuso de sessão detectado',
    'totp.ativado': 'Autenticador ativado',
    'senha.alterada': 'Senha alterada',
    'cliente.identificacao': 'Cliente se identificou',
    'cliente.conta_criada': 'Cliente criou acesso',
    'cliente.login': 'Cliente entrou',
    'cliente.codigo_invalido': 'Código de verificação inválido',
    'lgpd.exportacao': 'Dados do cliente exportados',
    'lgpd.exclusao_solicitada': 'Exclusão solicitada pelo titular',
    'setor.criado': 'Setor criado',
    'setor.alterado': 'Setor alterado',
    'usuario.criado': 'Usuário criado',
    'usuario.alterado': 'Usuário alterado',
    'usuario.desativado': 'Usuário desativado',
    'usuario.excluido': 'Usuário excluído',
    'usuario.convite': 'Convite de acesso enviado',
    'usuario.totp_redefinido': 'Autenticador redefinido pelo admin',
    'perfil.criado': 'Perfil criado',
    'perfil.alterado': 'Perfil alterado',
    'perfil.excluido': 'Perfil excluído',
};
//# sourceMappingURL=auditoria.js.map